import { IPermission, ShortEntityResponse} from 'reducers/Reducers.interfaces'
import { CAPermissionMap } from './Permissions.constant'
import { ApplicationPermissionMap } from 'core/selectors/Profile.selectors'

export function filterPermissions (permissions: IPermission[], profilePermissions: IPermission[]): IPermission[] {
  return permissions.filter(p => profilePermissions.find(pp => pp.id === p.id) )
}

export const hasSomePermissionsForCAItems = (permissions: Array<ShortEntityResponse>): boolean => {
  return permissions.some(item => CAPermissionMap.has(item.name))
}

export const getViewPermissions = (profilePermissions: Array<IPermission>) : Array<IPermission> => {
  const viewRole = new Array<IPermission>()
  const reg = new RegExp('^view_.*_license$', '')
  profilePermissions.map(perm => {
    if(perm.name !== ApplicationPermissionMap.canViewAMLicense && reg.test(perm.name.toLocaleLowerCase())) {
      viewRole.push(perm)
    }
  })
  return viewRole
}

export const getManagePermissions = (profilePermissions: Array<IPermission>) : Array<IPermission> => {
  const manageRole = new Array<IPermission>()
  const reg = new RegExp('^manage_.*_license$', '')
  profilePermissions.map(perm => {
    if(perm.name !== ApplicationPermissionMap.canManageAMLicense && reg.test(perm.name.toLocaleLowerCase())) {
      manageRole.push(perm)
    }
  })
  return manageRole
}

export const checkUncheckLicensePermissions = (profilePermissions: Array<IPermission>, currentPermissions: Record<string, boolean>): Record<string, boolean> => {
  const permissions = currentPermissions
  const viewAmLicense = profilePermissions.find(perm => perm.name === ApplicationPermissionMap.canViewAMLicense)
  const manageAmLicense = profilePermissions.find(perm => perm.name === ApplicationPermissionMap.canManageAMLicense)
  const viewRole = getViewPermissions(profilePermissions)
  const manageRole = getManagePermissions(profilePermissions)
  if(viewRole.length > 0 && Object.keys(currentPermissions).find(key => viewAmLicense && key === viewAmLicense.id)) {
    viewRole.map(perm => {
      if(permissions && viewAmLicense) {
        if(permissions[viewAmLicense.id]) {
          permissions[perm.id] = true
        } else {
          permissions[perm.id] = false
          delete permissions[viewAmLicense.id]
        }
      }
    })
}
if(manageRole.length > 0 && Object.keys(currentPermissions).find(key => manageAmLicense && key === manageAmLicense.id)) {
  manageRole.map(perm => {
    if(permissions && manageAmLicense) {
      if(permissions[manageAmLicense.id]) {
        permissions[perm.id] = true
      } else {
        permissions[perm.id] = false
        delete permissions[manageAmLicense.id]
      }
    }
  })
}
return permissions
}